/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {PERMISSIONS} from "../../components/auth/auth-constants";



export function sectionsStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state('app.wor', {
          abstract: true,
          data: {
            app: 'ADVERTISING'
          }
        }).state('app.adv', {
          abstract: true,
          data: {
            app: 'ADVERTISING'
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasAny(PERMISSIONS.manageAdvertising.apiKey) && !LocalUserPermissions.hasAny(PERMISSIONS.axAdvertiser.apiKey);
            }
          }
        }).state('app.pol', {
          abstract: true,
          data: {
            app: 'POLITICAL'
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.canEditPoliticalResources();
            }
          }
        }).state('app.dat-seg', {
          abstract: true,
          data: {
            app: 'DATA'
          },
          resolve: {
            readOnly: function() {
              return false;
            }
          }
        }).state('app.dat-map', {
          abstract: true,
          data: {
            app: 'DATA'
          },
          resolve: {
            readOnly: function() {
              return false;
            }
          }
        }).state('app.dat-q', {
          abstract: true,
          data: {
            app: 'DATA'
          },
          resolve: {
            readOnly: function() {
              return false;
            }
          }
        }).state('app.inv', {
          abstract: true,
          data: {
            app: 'ADVERTISING'
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasAny(PERMISSIONS.managePublishing.apiKey) && !LocalUserPermissions.hasAny(PERMISSIONS.axPublisher.apiKey);
            }
          }
        }).state('app.rep', {
          abstract: true,
          data: {
            app: 'ADVERTISING'
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey);
            }
          }
        });
  }, adnRouterHelper);
}
